import { useRef, useEffect, useState } from "react"

import { LineChart, Line, ResponsiveContainer, YAxis } from "recharts"

export default function Minimap({
  filtered,
  citiesName,
  tempFilter,
  cityColors,
  startIndexDataviz,
  endIndexDataviz,
  setEndIndexDataviz,
  setStartIndexDataviz,
  scaleChoice,
  log,
}) {
  const [begin, setBegin] = useState(0)
  const [end, setEnd] = useState(0)
  const brushBar = useRef()
  const slider = useRef()
  const leftHandle = useRef()
  const rightHandle = useRef()

  useEffect(() => {
    if (0 === end) {
      setEnd(document.body.clientWidth - 15)
    }
  }, [end])

  const filterRange = (weeks) =>
    weeks.filter(
      (week, index) => index >= startIndexDataviz && index <= endIndexDataviz,
    )

  const rangeFiltered = filterRange(filtered)

  const dragStart = function (event) {
    let debounce = false
    const target = event.target

    const step =
      Math.ceil(event.pageX || event?.targetTouches?.[0]?.pageX) - begin

    const handleMouseMove = function (event) {
      debounce = true

      setTimeout(() => {
        debounce = false
      }, 200)
      const isLeft = target.classList.contains("left-handle")
      const isRigth = target.classList.contains("right-handle")
      const isSlider = target.classList.contains("brush-slider")

      const max = document.body.clientWidth - 15

      let mousePosition = Math.ceil(event.x || event?.targetTouches?.[0]?.pageX)

      const pixelToWeek = (x) => Math.ceil(((filtered.length - 1) * x) / max)

      if (isLeft) {
        if (mousePosition < 0) {
          mousePosition = 0
        } else if (mousePosition > end - 15) {
          mousePosition = end - 15
        }

        setStartIndexDataviz(pixelToWeek(mousePosition))
        setBegin(mousePosition)
      } else if (isRigth) {
        if (mousePosition > max) {
          mousePosition = max
        } else if (mousePosition < begin + 15) {
          mousePosition = begin + 15
        }

        setEndIndexDataviz(pixelToWeek(mousePosition))
        setEnd(mousePosition)
      } else if (isSlider) {
        const width = end - begin

        let newBegin = mousePosition - step
        let newEnd = mousePosition - step + width

        if (newBegin < 0) {
          newBegin = 0
          newEnd = width
        }

        if (newEnd > max) {
          newEnd = max
          newBegin = max - width
        }
        setBegin(newBegin)
        setEnd(newEnd)

        setStartIndexDataviz(pixelToWeek(newBegin))
        setEndIndexDataviz(pixelToWeek(newEnd))
      }
    }

    const handleDragEnd = function (event) {
      document.removeEventListener("mousemove", handleMouseMove)
      document.removeEventListener("mouseup", handleDragEnd)
      document.removeEventListener("touchmove", handleMouseMove)
      document.removeEventListener("touchend", handleDragEnd)
    }

    document.addEventListener("mousemove", handleMouseMove)
    document.addEventListener("mouseup", handleDragEnd)
    document.addEventListener("touchmove", handleMouseMove)
    document.addEventListener("touchend", handleDragEnd)
  }

  return (
    <div className="minimap">
      <ResponsiveContainer
        width="100%"
        height={80}
        minHeight={80}
        maxHeight={80}
        classname="minimap-background"
      >
        <LineChart data={filtered}>
          <YAxis
            hide={true}
            scale={scaleChoice === "log" ? log : "auto"}
          ></YAxis>
          {citiesName.map((city, index) => (
            <Line
              type="monotone"
              connectNulls
              dot={false}
              dataKey={city}
              className={!tempFilter?.includes(city) && "desactivated"}
              key={city}
              stroke={
                tempFilter?.includes(city)
                  ? cityColors[index]
                  : "rgb(122, 122, 122)"
              }
              styles={{
                opacity: rangeFiltered.some((week) =>
                  Object.keys(week).includes(city),
                )
                  ? 1
                  : 0,
              }}
              strokeWidth={2}
              strokeDasharray={city === "national" ? "4 4" : "0 0"}
              name={city}
              id={city}
              isAnimationActive={true}
              animationDuration={100}
            ></Line>
          ))}
        </LineChart>
      </ResponsiveContainer>

      <svg width="100%" height="90" className="brush-bar" ref={brushBar}>
        <g className="" style={{ userSelect: "none" }}>
          <rect
            ref={slider}
            className=" brush-slider"
            stroke="purple"
            strokeWidth="2px"
            fill="blue"
            fillOpacity="0.1"
            x={begin + 15}
            y="0"
            width={(end || 15) - begin - 15}
            height="80"
            style={{
              cursor: "move",
              MozUserSelect: "none",
              KhtmlUserSelect: "none",
              userSelect: "none",
            }}
            onMouseDown={dragStart}
            onTouchStart={dragStart}
          ></rect>
          <g
            className=""
            tabIndex="0"
            role="slider"
            aria-label="Min value: undefined, Max value: undefined"
            aria-valuenow={begin}
            style={{ cursor: "col-resize" }}
          >
            <rect
              className="handle left-handle"
              ref={leftHandle}
              x={begin}
              y="0"
              width="15"
              height="81"
              stroke="none"
              onMouseDown={dragStart}
              onTouchStart={dragStart}
            ></rect>
            <line
              x1={begin}
              y1="44%"
              x2={begin + 14}
              y2="44%"
              fill="none"
              stroke="#fff"
            ></line>
            <line
              x1={begin}
              y1="40%"
              x2={begin + 14}
              y2="40%"
              fill="none"
              stroke="#fff"
            ></line>
          </g>
          <g
            className=""
            tabIndex="0"
            role="slider"
            aria-label="Min value: undefined, Max value: undefined"
            aria-valuenow={end}
            style={{ cursor: "col-resize" }}
          >
            <rect
              className="handle right-handle"
              ref={rightHandle}
              x={end}
              y="0"
              width="15"
              height="81"
              fill="#666"
              stroke="none"
              draggable
              onMouseDown={dragStart}
              onTouchStart={dragStart}
            ></rect>
            <line
              x1={end}
              y1="44%"
              x2={end + 14}
              y2="44%"
              fill="none"
              stroke="#fff"
            ></line>
            <line
              x1={end}
              y1="40%"
              x2={end + 14}
              y2="40%"
              fill="none"
              stroke="#fff"
            ></line>
          </g>
          <g className="">
            <text
              pointerEvents="none"
              className=""
              textAnchor="start"
              fill="#666"
            >
              <tspan x={begin + 20 > 100 ? begin - 100 : begin + 20} dy="1.2em">
                {filtered[startIndexDataviz].semaine}
              </tspan>
            </text>
            <text
              pointerEvents="none"
              className=""
              textAnchor="start"
              fill="#666"
            >
              <tspan x={end - 150 > begin ? end - 90 : end + 20} dy="1.2em">
                {filtered[endIndexDataviz].semaine}
              </tspan>
            </text>
          </g>
        </g>
      </svg>
    </div>
  )
}
